import { LANGUAGES } from '../constants/i18nConstants.js'

const DEFAULT_LOCALE = 'en'

export const localesTypes = {
  user: 'locale',
  system: 'systemLocale'
}
/**
 * Sets the user locale in the localStorage.
 * @param {*} locale
 * @param type
 */
export const setLocale = (locale, type = localesTypes.user) => {
  locale = LANGUAGES.map(({ code }) => code).includes(locale.toLowerCase()) ? locale.toLowerCase() : DEFAULT_LOCALE
  localStorage.setItem(type, locale)
  return locale
}

/**
 * Returns the user locale from the localStorage.
 * @param type
 * @returns
 */
export const getLocale = (type = localesTypes.user) => {
  return localStorage.getItem(type)
}

export const convertTranslationArrayToDict = json => {
  return json.reduce((acc, item) => {
    acc[item.key] = item.translation
    return acc
  }, {})
}

export const convertDictToTranslationArray = dict => {
  return Object.keys(dict).map(key => ({ key, translation: dict[key] }))
}

export function getBrowserLanguage(ctx) {
  // SSR: ctx.req is available
  if (ctx?.req?.headers) {
    const acceptLanguage = ctx.req.headers['accept-language']
    if (acceptLanguage) {
      // Parse the header, e.g., "en-US,en;q=0.9"
      return acceptLanguage.split(',')[0].split('-')[0]
    }
  }
  // Client-side: use browser API
  if (typeof window !== 'undefined' && window.navigator) {
    return window.navigator.language?.split('-')[0] || 'en'
  }
  // Default fallback
  return 'en'
}
